import type React from "react"
import { mainRoleTextClass } from "../../lib/role-colors"
import { cn } from "../../lib/utils"
import { getTranslations } from "../i18n"
import { useLocale } from "../locale-context"
import { useAuthenticatedUser } from "../user-context"
import { NotificationBell } from "./notification-bell"

export const MobileTopHeader: React.FC = () => {
	const { profile } = useAuthenticatedUser()
	const { locale } = useLocale()
	const t = getTranslations(locale)
	return (
		<header className="md:hidden fixed top-0 left-0 right-0 h-7 z-30 bg-card border-b border-border flex items-center justify-center px-2">
			<div className="absolute right-1 top-1/2 -translate-y-1/2">
				<NotificationBell placement="mobile-header" />
			</div>
			<span
				className={cn(
					"text-[9px] uppercase tracking-wider truncate leading-none",
					mainRoleTextClass(profile.mainRole),
				)}
			>
				{t.userMainRoles[profile.mainRole]}
			</span>
		</header>
	)
}
